// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__28CeR","subheader":"ReorderModal_subheader__UBc9L","listWrap":"ReorderModal_listWrap__3IVvc"};